import React, { useContext, useEffect, useState } from 'react'
import { LoadingIndicator } from '../../components/loadingIndicator/LoadingIndicator'
import { AxiosContext } from '../../core/AxiosContext'
import { useGlobalDispatch } from '../../core/GlobalContext'
import { TOAST_DUCK, TOAST_STATE } from '../../core/actions'
import { requestPasswordForgetOTPAction, resetPasswordForgetOTPAction } from '../../routes/login/LoginDuck'
import Button from '../button'
import Input from '../input'
import Text from '../text'
import * as styles from './PasswordReset.css'
import { errorSummary } from '../../utils/misc'

export const PasswordReset = ({ pan, phone, showResetPassword, setShowResetPassword }) => {
  const { publicAxios } = useContext(AxiosContext)
  const { toastDispatch } = useGlobalDispatch()
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')
  const [receivedOTP, setReceivedOTP] = useState('')
  const [resetPasswordMismatch, setResetPasswordMismatch] = useState(false)
  const [showResetPasswordInputs, setShowResetPasswordInputs] = useState(false)
  const [forgetPasswordResponse, setForgetPasswordResponse] = useState({ state: 'init' })
  const [resetPasswordResponse, setResetPasswordResponse] = useState({ state: 'init' })

  const handleNewPasswordChange = val => setNewPassword(val)
  const handleConfirmPasswordChange = val => setConfirmNewPassword(val)
  const handleReceivedOTPChange = val => setReceivedOTP(val)

  // Handling forget password responses.
  useEffect(() => {
    console.log('Forget password response: ', forgetPasswordResponse)
    if (forgetPasswordResponse.status === 'error') {
      setShowResetPassword(false)
      toastDispatch({
        type: TOAST_DUCK.SEND_TOAST,
        payload: {
          message:
            errorSummary(forgetPasswordResponse.response[0]) ||
            "Seems like you haven't registered with us. Click on Create Account to register",
          type: TOAST_STATE.ERROR,
        },
      })
    } else if (forgetPasswordResponse.status === 'success') {
      setShowResetPassword(true)
      setShowResetPasswordInputs(true)
    }
  }, [forgetPasswordResponse])

  // Handling reset password responses.
  useEffect(() => {
    console.log('Reset password response : ', resetPasswordResponse)
    if (resetPasswordResponse.status === 'error') {
      toastDispatch({
        type: TOAST_DUCK.SEND_TOAST,
        payload: {
          message: resetPasswordResponse.response,
          type: TOAST_STATE.ERROR,
        },
      })
    } else if (resetPasswordResponse.status === 'success') {
      setShowResetPassword(false)
      toastDispatch({
        type: TOAST_DUCK.SEND_TOAST,
        payload: {
          message: 'Password Updated successfully',
          type: TOAST_STATE.SUCCESS,
        },
      })
    }
  }, [resetPasswordResponse])

  // Check to show password reset form
  useEffect(() => {
    if (showResetPassword) {
      setShowResetPasswordInputs(false)
      requestPasswordForgetOTPAction({ username: pan, phone })(publicAxios, setForgetPasswordResponse)
    }
  }, [showResetPassword])

  // Handling reset password mismatch
  useEffect(() => {
    if (newPassword === confirmNewPassword) {
      setResetPasswordMismatch(false)
    } else {
      setResetPasswordMismatch(true)
    }
  }, [newPassword, confirmNewPassword])

  //   Handling reset button
  const handlePasswordReset = () => {
    if (!resetPasswordMismatch) {
      if (receivedOTP === '') {
        toastDispatch({
          type: TOAST_DUCK.SEND_TOAST,
          payload: {
            message: 'Please enter the received OTP',
            type: TOAST_STATE.ERROR,
          },
        })
      } else {
        resetPasswordForgetOTPAction({
          password: newPassword,
          confirmPassword: confirmNewPassword,
          receivedOTP: receivedOTP,
          responses: forgetPasswordResponse.response,
        })(publicAxios, setResetPasswordResponse)
      }
    }
  }
  //  Handling back button
  const handleBackButton = () => {
    setShowResetPassword(false)
    setConfirmNewPassword('')
    setNewPassword('')
    setReceivedOTP('')
  }

  return (
    <div className={styles.card}>
      <div className={styles.passwordTitle}>
        <Text size='2' value='Password Reset'></Text>
        <Text
          size='1'
          value='OTP will be sent to the mobile number linked to your PAN.'
          color='var(--reset-password-label-color)'></Text>
      </div>
      {showResetPasswordInputs ? (
        <div className={styles.inputs}>
          <form>
            <Text
              size={0.9}
              color='var(--reset-password-label-color)'
              className={styles.welcomeText}
              value='Received OTP'
            />
            <Input
              className={styles.input}
              placeholder='Enter the received OTP'
              value={receivedOTP}
              onChange={handleReceivedOTPChange}
            />
            <Text
              size={0.9}
              color='var(--reset-password-label-color)'
              className={styles.welcomeText}
              value='New password'
            />
            <Input
              className={styles.input}
              placeholder='Enter your password'
              value={newPassword}
              onChange={handleNewPasswordChange}
              type='password'
            />
            <Text
              size={0.9}
              color='var(--reset-password-label-color)'
              className={styles.welcomeText}
              value='Confirm Password'
            />
            <Input
              className={styles.input}
              placeholder='Confirm your password'
              value={confirmNewPassword}
              onChange={handleConfirmPasswordChange}
              type='password'
            />
          </form>
        </div>
      ) : (
        <div>
          <LoadingIndicator />
        </div>
      )}
      <div className={styles.errorMessage}>
        <Text size='0.85' color='var(--login-error-message-color)' bold>
          {confirmNewPassword != '' && resetPasswordMismatch ? 'Password Not Matching' : ''}
        </Text>
      </div>

      <div className={styles.buttonsWrapper}>
        <Button
          className={styles.backToLogin}
          label='Back to login page'
          type='skeleton'
          handleClick={handleBackButton}
          color={'var(--login-btn-color)'}
        />
        <Button
          label='Reset Password'
          disabled={resetPasswordMismatch}
          handleClick={handlePasswordReset}
          type='signin'
        />
      </div>
    </div>
  )
}
